import styles from './TableSkeletonRow.module.scss';

import Skeleton from '@mui/material/Skeleton';

export function TableSkeletonRowV8(props: { style?: React.CSSProperties }) {
  return (
    <div style={props.style}>
      <Skeleton className={styles.skeleton} />
    </div>
  );
}
